/**
 * How the held person's gun answers the crosshair (67.10; a presentation flag, like the fine
 * ground's). `solved`: the gun elevates to land the shot where the crosshair rests, as the bots
 * aim (core/aimSolve.ts). `direct`: the shot leaves along the line of sight and the impact dot
 * shows where it drops — the old behaviour, with a crosshair that stays put.
 *
 * Read from `?aim=direct` by the host; the Lab sets the override before it launches (it starts the
 * match in-page, with no URL to read).
 */

export type AimMode = 'solved' | 'direct';
export const AIM_MODES: readonly AimMode[] = ['solved', 'direct'];
export const AIM_MODE_DEFAULT: AimMode = 'solved';

let override: AimMode | null = null;

/** The Lab's launch: `null` goes back to the URL / the default. */
export function setAimMode(m: AimMode | null): void { override = m; }

/** The mode in force: the Lab's override, else the page's `?aim=`, else the default. */
export function aimMode(): AimMode {
  if (override) return override;
  try {
    const q = typeof location !== 'undefined' ? new URLSearchParams(location.search).get('aim') : null;
    return q === 'direct' || q === 'solved' ? q : AIM_MODE_DEFAULT;
  } catch { return AIM_MODE_DEFAULT; }
}
